import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Appli } from '../../models/appli';
import { AuthService } from '../../services/auth.service';
import { AuthGuard } from '../../services/guards/auth.guard';
import { Router } from '@angular/router';
import { environment } from '../../../environment/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AdminAppliService {
  applis: Observable<Appli[]>; //Assuming we have api endpoint that returns an array of Appli objects
  baseUrl = environment.baseUrl;
  constructor(
    public http:HttpClient,
    private _authService: AuthService,
    private _authguard: AuthGuard,
    private _router: Router,

  ) { }

  getApplis1(data): Observable<any> {
    console.log(this.baseUrl,"DDDDDDDDDDDDDDDDDDDDDDDDdd");
    console.log(this._authService.idToken);
    const httpOptions = {
      headers: new HttpHeaders({
        "Accept": "application/json",
        "httpMethod":'GET',
        "Authorization": this._authService.idToken,
          // "Authorization": 'eyJraWQiOiJOeE1vNGVCeHNSaEw2TFVWK2FaQjBDT3hYU25zaTdGblpqSXRscEwwSW5BPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI3YjkxYTAxMy1lZDAyLTQ0ZTgtOTlmNS05MTA1YWU4Njk5Y2UiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tXC91cy1lYXN0LTFfeTczTUJoUGs4IiwicGhvbmVfbnVtYmVyX3ZlcmlmaWVkIjpmYWxzZSwiY29nbml0bzp1c2VybmFtZSI6IjdiOTFhMDEzLWVkMDItNDRlOC05OWY1LTkxMDVhZTg2OTljZSIsImdpdmVuX25hbWUiOiJ2aXB1bCIsIm9yaWdpbl9qdGkiOiJkOTkzM2EwZS1hNzExLTRjZGMtYmNlNy05NDcxYmE3MjlhMTQiLCJhdWQiOiIzdm9vNmdwdHNoaXE2OTZ0a3JlN2ZnZHE1aCIsImV2ZW50X2lkIjoiMzhmNmNlZTMtY2I3Yy00NDQ1LWE2MTUtYmQ2ZDgyZTE2MTE0IiwidG9rZW5fdXNlIjoiaWQiLCJhdXRoX3RpbWUiOjE3MTcxMjEyNjYsInBob25lX251bWJlciI6Iis5NDUyNDE4Nzk5IiwiZXhwIjoxNzE3MTI0ODY2LCJpYXQiOjE3MTcxMjEyNjYsImp0aSI6ImFmZjVhNDQzLTUxZmUtNGVjYy05YWFiLTQ4MGJkMjJjNDNlNCIsImVtYWlsIjoidmlwdWw0OV9hZ3Jhd2FsQHlhaG9vLmNvLmluIn0.f2PW81HZA3fQAhuxe79buAZflJfFxlPY4OB8_hvDHT6C7mDf2dnGiYTWzelRRsA1OnFUopqKSdi7jPmobSa9abS8P0YeMOAsg-nrsVpzwMoMzkKvquj7i1WqXndJc0d9NxLKNyTwe619xYiqjYKks3_-HK1cbgSGimYYr_RSwlx14aWoEHX0roLyVrCwgLPCeG5KKdU0Fi1raVG1C26IhhPghhN4n8GUkoeA3v1we5ynxo_VuMY4n_Nnym8vdDmulPcT6u6tcibE38M791W7IWnsITzvgjUI2YfjaeegCZRtABCj7eHIdkQUspP7DcFFwJ6KqPVZLRUoBQb7syR-KQ',
        // "Authorization":'Bearer' + this._authService.accessToken,
      })
    };
    return this.http.get(this.baseUrl+"/appli/admin", httpOptions)
    // console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$%%%%%%");
    // console.log(this.baseUrl+"/appli/admin", httpOptions)
    // return this.http.get("https://q2q37adaxi.execute-api.us-east-1.amazonaws.com/osm-devuseast1-blue-apistage"+"/appli/admin", httpOptions)
  }

  addAppli(appli) {
    // return this.appliscollection.add(appli);

    const httpOptions = {
      headers: new HttpHeaders({
        "Accept": "application/json",
        // "httpMethod":'POST',
        // "Authorization": this._authService.idToken,
        // "Authorization":'Bearer' + this._authService.accessToken,
      })}

      return this.http.post(this.baseUrl+"/appli/admin/add", appli, httpOptions)
  }

  deleteAppli(appli) {
    // return this.appliscollection.add(appli);

    const httpOptions = {
      headers: new HttpHeaders({
        "Accept": "application/json",
        "httpMethod":'POST',
        "Authorization": this._authService.idToken,
        // "Authorization":'Bearer' + this._authService.accessToken,
      })}
      return this.http.post(this.baseUrl+"/appli/admin/delete", appli, httpOptions)
  }

  updateAppli(appli) {
    // return this.appliscollection.add(appli);

    const httpOptions = {
      headers: new HttpHeaders({
        "Accept": "application/json",
        // "httpMethod":'POST',
        // "Authorization": this._authService.idToken,
        // "Authorization":'Bearer' + this._authService.accessToken,
      })}
      return this.http.post(this.baseUrl+"/appli/admin/update", appli, httpOptions)
  }



}
